import { useState } from 'react';

import { useIntl } from 'react-intl';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';
import SectionMessage from '@atlaskit/section-message';

import { publishUiEvent } from 'src/utils/analytics/publish';
import { atlassianStore as store } from 'src/utils/store';

import {
  FIX_FLAKY_LEARN_MORE_URL,
  FIX_FLAKY_UNAVAILABLE_DISMISSED_KEY,
} from '../constants';
import { messages } from '../messages';

export const FixFlakyUnavailable = () => {
  const { formatMessage } = useIntl();
  const [isDismissed, setIsDismissed] = useState(
    !!store.get(FIX_FLAKY_UNAVAILABLE_DISMISSED_KEY)
  );

  if (isDismissed) {
    return null;
  }

  const handleDismiss = () => {
    publishUiEvent({
      source: 'FixFlakyUnavailable',
      actionSubjectId: 'fixFlakyUnavailableDismissed',
      actionSubject: 'button',
      action: 'clicked',
    });
    store.setStrictlyNecessaryItem(FIX_FLAKY_UNAVAILABLE_DISMISSED_KEY, true);
    setIsDismissed(true);
  };

  return (
    <SectionMessage isDismissible onDismiss={handleDismiss}>
      {formatMessage(messages.fixFlakyUnavailable, {
        learnMoreLink: (
          <CustomThemeButton
            appearance="link"
            href={FIX_FLAKY_LEARN_MORE_URL}
            rel="noopener noreferrer"
            spacing="none"
            target="_blank"
          >
            {formatMessage(messages.learnMoreLink)}
          </CustomThemeButton>
        ),
      })}
    </SectionMessage>
  );
};
